/* eslint-disable */
import { Product } from '../entities/Product'
import { Accordion } from '../entities/Accordion'
class ProductsWrapper {
	container
	products = []
	accordions = []
	setContainer (container) {
		this.container = container
		const accordions = this.navWrapper.container.querySelectorAll('.accordion');

		[...accordions].forEach((accordion, key) => {
			const accordionEnity = new Accordion(accordion)
			this.accordions[key] = accordionEnity
			const list = accordion.querySelectorAll('[data-product]');
			[...list].forEach(item => {
				this._createProduct(item, key)
			})
		})
		
		return this
	}

	setNavWrapper(wrapper) {
		this.navWrapper = wrapper
	}

	closeAll(){
		this.accordions.forEach(accordion => {
			accordion.close()
		})
	}

	open(pk){
		this.accordions[pk].open()
	}

	isOpen(pk){
		return this.accordions[pk].isOpen
	}

	_createProduct (element, accordion) {
		const product = new Product()
		const id = element.dataset.product
		product.id = id
		const productElement = this.container.querySelector('[data-product="'+id+'"]');

		if(!this.navWrapper.list[id]) return false
		product.nav = this.navWrapper.list[id]
		product.element = productElement
		product.accordion = accordion
		this.products[id] = product
	}
}

const productsWrapper = new ProductsWrapper()
export {
	ProductsWrapper,
	productsWrapper
}
